/**
 * @file index.tsx.tsx
 *
 * @fileoverview Renders button for sharing on LinkedIn.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import LinkedinColorIcon from '~/vcl/icons/color/Linkedin';
import { FormattedMessage } from 'react-intl';
import LinkedinIcon from '~/vcl/icons/Linkedin';

export default function LinkedInSharingButton({
  url,
  coloredIcons = true,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_linkedin"
          defaultMessage="on LinkedIn"
        />
      }
      urlToShare={url}
      href="http://www.linkedin.com/shareArticle?mini=true&url="
      IconComponent={coloredIcons ? LinkedinColorIcon : LinkedinIcon}
      {...props}
    />
  );
}
